import React from 'react';
import { useController } from 'react-hook-form';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import { ConfirmWidgetValue, IConfirmWidget } from './IConfirmWidget';
import { ConfirmWidgetLayoutComponent } from './components/ConfirmWidgetLayoutComponent';

export interface IConfirmWidgetComponentProps
  extends IWidgetComponentProps<IConfirmWidget> {}

/**
 * Componente che gestisce la logica di un widget di tipo `Confirm`
 * nel Form.
 */
export function ConfirmWidgetFormComponent(
  props: IConfirmWidgetComponentProps,
) {
  const { widget } = props;

  const options = getWidgetProps(props);

  const {
    field: { value, onChange, onBlur },
  } = useController({
    name: options.name,
    defaultValue: ConfirmWidgetValue.Unconfirmed,
  });

  return (
    <ConfirmWidgetLayoutComponent
      options={options}
      onChange={onChange}
      onBlur={onBlur}
      confirmationValue={value}
      {...props}
    />
  );
}
